<template>
  <b-nav-item-dropdown class="dropdown-notification mr-25" menu-class="dropdown-menu-media" right>
    <template #button-content>
      <feather-icon v-if="notifications.length > 0" :badge="notifications.length" badge-classes="bg-danger"
        class="text-body" icon="BellIcon" size="21" />
      <feather-icon v-else :badge="notifications.length" badge-classes="bg-danger" class="text-body" icon="BellIcon"
        size="21" />
    </template>

    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex justify-content-between align-items-center p-1">
        <h4 class="notification-title mb-0 mr-auto d-flex align-items-center">
          <b-form-checkbox class="d-flex align-items-center" v-model="allNotification"
            @change="handleCheckAll($event)"></b-form-checkbox>Notifications
        </h4>
        <b-badge pill variant="light-primary">
          {{ notifications.length }} New
        </b-badge>
      </div>
    </li>

    <div class="scrollable-container media-list scroll-area overflow-auto" tagname="li">
      <div v-for="notification in notifications" :key="notification.id" class="p-1">
        <div class="d-flex">
          <div>
            <div class="notiContainer d-flex align-items-center h-100">
              <b-form-checkbox v-model="notification.action"
                @change="handleCheck($event, notification)"></b-form-checkbox>
              <b-avatar size="32" :variant="getColor(notification)">
                <feather-icon icon="CheckIcon" />
              </b-avatar>
            </div>
          </div>
          <div class="media-heading pl-1 w-100">
            <div class="w-100 d-flex justify-content-end">
              <b-badge :variant="getColor(notification)">
                <small>
                  {{ moment(notification.enterdatetime).format('DD/MM/YYYY h:m A') }}
                </small>
              </b-badge>
            </div>
            <span :class="`font-weight-bolder text-${getColorSmall(notification)}`" v-html="notification.text">
            </span>
            <p>
              <small :class="`notification-text w-100 text-${getColorSmall(notification)}`"><b>{{ notification.title
                  }}</b></small>
            </p>
          </div>
        </div>
      </div>
    </div>

    <li class="dropdown-menu-footer">
      <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" block @click="handleRead()">Read
        {{ notificationIds.length == 0 ? 'all' : '' }} notifications</b-button>
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Ripple from "vue-ripple-directive";
import axios from "axios";
import moment from 'moment'
import { REALTIME_NOTIFICATION_BUS_EVENT } from '@/services/realtimeNotificationService'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      moment,
      notifications: [],
      accessToken: localStorage.getItem("accessToken"),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      checkedItem: [],
      notificationIds: [],
      allNotification: false,
      notificationPollTimer: null,
      onWindowFocus: null,
    };
  },
  computed: {
    getColor() {
      const obj = {
        sitevisit: 'light-success',
        channelpartner: 'light-danger',
        franchise: 'light-danger',
        employee: 'light-danger',
        task: 'light-warning',
        lead: 'light-primary',
        sales: 'light-info',
        none: 'light-secondary',
        offer: 'light-danger',
      }

      return (item) => {
        for (const key in obj) {
          if (item.title.replace(/\s/g, '').toLowerCase().includes(key)) {
            return obj[key]
          }
        }
        return 'light-secondary'
      }
    },
    getColorSmall() {
      const obj = {
        sitevisit: 'success',
        channelpartner: 'danger',
        franchise: 'danger',
        employee: 'danger',
        task: 'warning',
        lead: 'primary',
        sales: 'info',
        none: 'secondary',
        offer: 'danger',
      }

      return (item) => {
        for (const key in obj) {
          if (item.title.replace(/\s/g, '').toLowerCase().includes(key)) {
            return obj[key]
          }
        }
        return 'secondary'
      }
    },
  },
  mounted() {
    this.getNotification()

    const bus = this.$eventBus || this.$root
    if (bus) {
      bus.$on(REALTIME_NOTIFICATION_BUS_EVENT, this.onRealtimeNotification)
    }

    // Bell list refresh (realtime service handles Chrome popups + faster poll when no Pusher)
    this.notificationPollTimer = setInterval(() => {
      this.getNotification()
    }, 30000)

    this.onWindowFocus = () => {
      if (document.visibilityState === 'visible') {
        this.getNotification()
      }
    }
    document.addEventListener('visibilitychange', this.onWindowFocus)
    window.addEventListener('focus', this.onWindowFocus)
  },
  beforeDestroy() {
    const bus = this.$eventBus || this.$root
    if (bus) {
      bus.$off(REALTIME_NOTIFICATION_BUS_EVENT, this.onRealtimeNotification)
    }
    if (this.notificationPollTimer) {
      clearInterval(this.notificationPollTimer)
    }
    if (this.onWindowFocus) {
      document.removeEventListener('visibilitychange', this.onWindowFocus)
      window.removeEventListener('focus', this.onWindowFocus)
    }
  },
  methods: {
    handleCheckAll(e) {
      if (e) {
        this.notifications.map((noti) => {
          noti.action = true
          this.notificationIds.push(noti.id)
        })
      } else {
        this.notifications.map((noti) => {
          noti.action = false
        })
        this.notificationIds = []
      }
    },
    handleCheck(e, noti) {
      noti.action = e
      if (e) {
        this.notificationIds.push(noti.id)
      } else {
        const index = this.notificationIds.indexOf(noti.id)
        this.notificationIds.splice(index, 1)
      }
    },
    async handleRead() {
      if (this.notificationIds.length === 0) {
        this.notificationIds = []
        this.notifications.map((noti) => {
          this.notificationIds.push(noti.id)
        })
      }
      await axios({
        method: 'POST',
        url: `${this.baseApi}/change-notification-status`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.accessToken}`,
        },
        data: JSON.stringify({
          ids: this.notificationIds,
        }),
      }).then(() => {
        this.getNotification()
      })
    },
    async getNotification() {
      const token = localStorage.getItem('accessToken')
      if (!token) {
        return
      }
      await axios({
        method: 'GET',
        url: `${this.baseApi}/send-notification`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        this.notifications = response.data
      })
    },
    async onRealtimeNotification(payload) {
      console.log('payload', payload)
      await this.getNotification()
      const message = payload && (payload.message || payload.text)
      const title = (payload && payload.title) || 'New notification'
      if (message) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title,
            text: message,
            icon: 'BellIcon',
            variant: 'primary',
          },
        })
      }
    },
  },
  setup() {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    return {
      perfectScrollbarSettings,
    }
  },
}
</script>
<style>
.notiContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
